export const getSvgPath = (iconName: IconName) => ICONS[iconName] || "";

export type IconName = keyof typeof ICONS;

export const ICONS = {
	angleDown:
		"M455.9,816.9L25.1,386.2c-29.8-29.8-29.8-77.9,0-107.4l71.6-71.6c29.8-29.8,77.9-29.8,107.4,0l305.3,305.3l305.3-305.3 c29.8-29.8,77.9-29.8,107.4,0l72.2,71.3c29.8,29.8,29.8,77.9,0,107.4L563.5,816.6C533.8,846.7,485.6,846.7,455.9,816.9z",

	square:
		"M914.3,0H109.7C49.1,0,0,49.1,0,109.7v804.6C0,974.9,49.1,1024,109.7,1024h804.6c60.6,0,109.7-49.1,109.7-109.7V109.7 C1024,49.1,974.9,0,914.3,0z M900.6,914.3H123.4c-7.5,0-13.7-6.2-13.7-13.7V123.4c0-7.5,6.2-13.7,13.7-13.7h777.1 c7.5,0,13.7,6.2,13.7,13.7v777.1C914.3,908.1,908.1,914.3,900.6,914.3z",

	squareChecked:
		"M914.3,1024H109.7C49.1,1024,0,974.9,0,914.3V109.7C0,49.1,49.1,0,109.7,0h804.6C974.9,0,1024,49.1,1024,109.7v804.6 C1024,974.9,974.9,1024,914.3,1024z M446.4,799.9L867,379.3c14.3-14.3,14.3-37.4,0-51.7l-51.7-51.7c-14.3-14.3-37.4-14.3-51.7,0 l-343,343L260.4,458.7c-14.3-14.3-37.4-14.3-51.7,0L157,510.4c-14.3,14.3-14.3,37.4,0,51.7l237.7,237.7 C409,814.1,432.1,814.1,446.4,799.9L446.4,799.9z",
} as const;
